import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import AppModel from '../DataModel/AppModel';

export default
@observer class SelectParentLocation extends Component {

  handleChange(event, index, value) {
    //console.log(arguments);
    this.props.target.id_parent = value;
  }

  parentChoices(targetLocationId) {
    var list = [];
    if(AppModel.allowAddingRootLocations) {
      list.push( <MenuItem  key={"root"}
                            value={"root"}
                            primaryText={uiMsg('SPL_NOT_CONTAINED_BY_OTHER',"Not contained by other area.")}
                            />);
    }
    // The set of all location ids that are disallowed as parents for this
    // location (itself and its children)
    var filteredIds = new Set();
    filteredIds.add(targetLocationId);
    let targetLocation=AppModel.parentLocationChoices.find(
      l => l.id==targetLocationId
    );
    if(targetLocation!=null) {
      // Add all child locations ids to the filtered set as well
      let locationQueue=targetLocation.children.map( e => e);
      while(locationQueue.length>0) {
        var loc = locationQueue.pop();
        filteredIds.add(loc.id);
        if(loc.children) {
          loc.children.forEach( l => {locationQueue.push(l)});
        }
      }
    }
    AppModel.parentLocationChoices.forEach(function(parentLocation) {
      if(!filteredIds.has(parentLocation.id)) {
        list.push(
          <MenuItem key={parentLocation.id}
                    value={parentLocation.id}
                    primaryText={ parentLocation.indentStr +
                                  parentLocation.typeName+": "+
                                  parentLocation.name}/>)
      }
    });
    return list;
  }

  render() {
    var targetLocationId = this.props.target.id;
    // If there are no locations to pick as a parent :
    if(AppModel.parentLocationChoices.length==0 &&
      !AppModel.allowAddingRootLocations) {
      throw new Error("parentLocationChoices.length==0 and AppModel.allowAddingRootLocations is false.  No win situation");
    }
    return (
      <SelectField
          floatingLabelText={uiMsg('SPL_CONTAINING_AREA',"Containing area")}
          hintText={uiMsg('SPL_ADD_ROOM_WITHIN',"Add room inside")}
          value={this.props.target.id_parent}
          fullWidth={true}
          onChange={this.handleChange.bind(this)}>
          {this.parentChoices(targetLocationId)}
      </SelectField>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SelectParentLocation.jsx
 **/